import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7ca86725&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=7ca86725&prod&scoped=true&lang=css"
import style1 from "./Footer.vue?vue&type=style&index=1&id=7ca86725&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca86725",
  null
  
)

export default component.exports